module.exports = __webpack_public_path__ + "icons/original/small/small-d2.f554d768eed7fb9c2ac1361d80a08e82.png";


//////////////////
// WEBPACK FOOTER
// ./src/web/icons/original/small/small-d2.png
// module id = xDob
// module chunks = app